import React, { CSSProperties, useEffect } from 'react'

import s from './styles.module.scss'

//https://stackoverflow.com/questions/69317628/how-to-insert-a-hubspot-form-in-a-react-js-app
const HubspotForm = ({
  id,
  portalId,
  formId,
  region,
  style,
  styleForm,
}: {
  id: string
  portalId: string
  formId: string
  region: string
  style?: CSSProperties
  styleForm?: CSSProperties
}) => {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENV === 'development') {
      return
    }

    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (window.hbspt) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.hbspt.forms.create({
          target: `#${id}`,
          portalId,
          formId,
          region,
        })
      }
    })
  }, [])
  return (
    <div className={s.content} style={style}>
      <div id={id} className={s.hubspotContainer} style={styleForm} />
    </div>
  )
}

export default HubspotForm
